import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    
    return Promise.reject(error);
  }
);

// Get all audios with optional filtering
export const getAllAudios = async (params = {}) => {
  const response = await api.get('/audios', { params });
  return response.data;
};

// Get audio by ID
export const getAudioById = async (id) => {
  const response = await api.get(`/audios/id/${id}`);
  return response.data;
};

// Get audio by slug
export const getAudioBySlug = async (slug) => {
  const response = await api.get(`/audios/slug/${slug}`);
  return response.data;
};

// Get audios by genre
export const getAudiosByGenre = async (genreId, params = {}) => {
  const response = await api.get(`/audios/genre/${genreId}`, { params });
  return response.data;
};
export const getAllAudiosByGenre = async (genreId, params = {}) => {
  const response = await api.get(`/audios/genre-id/${genreId}`, { params });
  return response.data;
};

// Get audios by language
export const getAudiosByLanguage = async (language, params = {}) => {
  const response = await api.get(`/audios/language/${language}`, { params });
  return response.data;
};

// Get popular audios
export const getPopularAudios = async (params = {}) => {
  const response = await api.get('/audios/popular', { params });
  return response.data;
};

// Like an audio
export const likeAudio = async (id) => {
  const response = await api.post(`/audios/${id}/like`);
  return response.data;
};


export const getSimilarAudios = async (id, params = {}) => {
    const response = await api.get(`/audios/${id}/similar`, { params });
    return response.data;
  };
  export const getNewSimilarAudios = async (id, params = {}) => {
    const response = await api.get(`/audios/${id}/new-similar`, { params });
    return response.data;
  };

  

export const getAudiosByAudioType = async (audioType, params = {}) => {
    const response = await api.get(`/audios/audio-type/${audioType}`, { params });
    return response.data;
  };


  export const getAudiosByGenreName = async (genreName, params = {}) => {
    const response = await api.get(`/audios/genre-name/${genreName}`, { params });
    return response.data;
  };

  export const getAudiosByGenreSlug = async (slug, params = {}) => {
    const response = await api.get(`/audios/genre-slug/${slug}`, { params });
    return response.data;
  };